// extracted by mini-css-extract-plugin
export default {"basicLogo":"style_basicLogo__bY5vI","content":"style_content__LJu-6","logo":"style_logo__rRXHB","beta":"style_beta__jEBxZ"};